import { render, staticRenderFns } from "./ProductListItem.vue?vue&type=template&id=dadc5e2a&scoped=true&"
import script from "./ProductListItem.vue?vue&type=script&lang=js&"
export * from "./ProductListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductListItem.vue?vue&type=style&index=0&id=dadc5e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadc5e2a",
  null
  
)

export default component.exports